// 体験閲覧履歴
export const WABUNKA_EXPERIENCE_BROWSING_HISTORY = 'webh';
